// socket-init.ts
import io from 'socket.io-client';
import { getEnvironmentConfig } from '@/config/environment';

interface SocketOptions {
  game: 'starwars' | 'storm';
  role?: string;
  sessionId?: string;
  teamId?: string;
  userId?: string;
  userName?: string;
}

export function createSocket({
  game,
  role = 'player',
  sessionId = '',
  teamId = '',
  userId = '',
  userName = '',
}: SocketOptions): any {
  // Utiliser la configuration d'environnement runtime
  const envConfig = getEnvironmentConfig();
  const SOCKET_BASE_URL = envConfig.socketUrl;

  // 👇 Chemin Socket.IO unifié pour tous les jeux
  const socketPath = `/socket.io`;

  console.log(`[${game.toUpperCase()}] Creating socket connection:
  - Environment: ${envConfig.isProduction ? 'PRODUCTION' : 'DEVELOPMENT'}
  - Base URL: ${SOCKET_BASE_URL}
  - Socket.IO Path: ${socketPath}
  - Build mode: ${import.meta.env.MODE}
  - Current origin: ${window.location.origin}`);

  try {
    const socket = io(SOCKET_BASE_URL, {
      path: socketPath,
      transports: ['websocket', 'polling'],
      forceNew: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      timeout: 20000,
      query: {
        game,
        role,
        sessionId,
        teamId,
        userId,
        userName
      }
    });

    socket.on('connect', () => {
      console.log(`[${game.toUpperCase()}] ✅ Connected to socket server at: ${SOCKET_BASE_URL}${socketPath}`);
    });

    socket.on('connect_error', (err: any) => {
      console.error(`[${game.toUpperCase()}] ❌ Socket connection error:`, err.message || err);
      console.error('Debug info:', {
        socketUrl: SOCKET_BASE_URL,
        socketPath,
        currentOrigin: window.location.origin,
        isProduction: envConfig.isProduction
      });
    });

    return socket;
  } catch (err) {
    console.error(`[${game.toUpperCase()}] ❌ Error creating socket:`, err);
    throw err;
  }
}
